import { EditFilled, SearchOutlined } from '@ant-design/icons'
import { message, Popconfirm, Segmented, Table, Tooltip, Button, Form, Select, Modal, Input } from 'antd'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { FaTrash } from 'react-icons/fa'
import { SERVER_ADDRESS } from '../../Config/Config'
import { GrPowerReset } from 'react-icons/gr'

const ViewEducationDetails = () => {
    const [selectedOption,setSelectedOption] = useState('Education Level')
    const [loading,setLoading] = useState(false)
    const options = ['Education Level','Degree','Subject']
    const [data,setData] = useState([]);
    const [filteredData,setFilteredData]=useState([]);
    const [educationModal,setEducationModal] = useState(false)
    const [degreeModal,setDegreeModal] = useState(false)
    const [subjectModal,setSubjectModal] = useState(false)
    const [educationForm] = Form.useForm();
    const [degreeForm] = Form.useForm();
    const [subjectForm] = Form.useForm();
    const [educationRow,setEducationRow] = useState(null)
    const [degreeRow,setDegreeRow] = useState(null)
    const [subjectRow,setSubjectRow] = useState(null)
    const [education,setEducation] = useState([]);
    const [degree,setDegree] = useState([])
    const [educationSearchTerm,setEducationSearchTerm] = useState('');
    const [degreeSearchTerm,setDegreeSearchTerm] = useState('');
    const [subjectSearchTerm,setSubjectSearchTerm] = useState('');
    const [selectedEducationId, setSelectedEducationId] = useState(null);
    const [selectedDegreeId,setSelectedDegreeId] = useState(null)

    const handleCloseEducationModal = ()=>{
      setEducationModal(false)
      educationForm.resetFields();
    }
  
    const handleCloseDegreeModal = ()=>{
      setDegreeModal(false)
      degreeForm.resetFields();
    }
  
    const handleCloseSubjectModal = ()=>{
      setSubjectModal(false)
      subjectForm.resetFields();
    }

    const handleEducationEdit = (record)=>{
      setEducationRow(record)
      educationForm.setFieldsValue({['education_level']:record['education_level']})
      setEducationModal(true)
    }
  
    const handleDegreeEdit = (record)=>{
      setDegreeRow(record)
      degreeForm.setFieldsValue({['education_level_id']:record['education_level_id'],['degree']:record['degree']})
      setDegreeModal(true)
    }
  
    const handleSubjectEdit =async (record)=>{
      setSubjectRow(record)
      const selectedEducation = education.find(item => item.value === record.education_level_id);
      await fetchDegree(record.education_level_id);
      subjectForm.setFieldsValue({
        education_level_id: selectedEducation ? selectedEducation.value : null,
        degree_id: record.degree_id, // Now the correct states should be loaded
        subject: record.subject,
      });
      setSubjectModal(true)
    }

    const handleEducationUpdate = async(values)=>{
      const payload = {
        flag:1,
        id:educationRow.id,
        education:values.education_level
      }
      try {
        const response = await axios.post(`${SERVER_ADDRESS}/api/editEducation`,payload)
        if(response.status === 200 && response.data.result === 1){
          const updatedData = filteredData.map(item =>
            item.id === educationRow.id ? { ...item, education_level: values.education_level } : item
          );
          setFilteredData(updatedData)
          message.success({content:`${response.data.message}`})
          setEducationModal(false);
        }
      } catch (error) {
        message.error({content:"Something Went Wrong !"})
      }
    }

    const handleDegreeUpdate = async(values)=>{
      const payload = {
        flag:2,
        id:degreeRow.id,
        education_id:values.education_level_id,
        degree:values.degree,
      }
      try {
        const response = await axios.post(`${SERVER_ADDRESS}/api/editEducation`,payload)
        if(response.status === 200 && response.data.result === 1){
          const selectedEducation = education.find(item => item.value === values.education_level_id);
          const updatedData = filteredData.map(item =>
            item.id === degreeRow.id ? { ...item, degree: selectedEducation ? selectedEducation.label : "", degree:payload.degree } : item
          );
          setFilteredData(updatedData)
          message.success({content:`${response.data.message}`})
          setDegreeModal(false);
        }
      } catch (error) {
        message.error({content:"Something Went Wrong !"})
      }
    }

    const handleSubjectUpdate = async(values)=>{
      const payload = {
        flag:3,
        id:subjectRow.id,
        education_id:values.education_level_id,
        degree_id:values.degree_id,
        subject:values.subject,
      }
      try {
        const response = await axios.post(`${SERVER_ADDRESS}/api/editEducation`,payload)
        if(response.status === 200 && response.data.result === 1){
          const selectedEducation = education.find(item => item.value === values.education_level_id);
          const selectedDegree = degree.find(item => item.value === values.degree_id);
          const updatedData = filteredData.map(item =>
            item.id === subjectRow.id ? { ...item, education_level: selectedEducation ? selectedEducation.label : "",degree:selectedDegree ? selectedDegree.label : "", subject:payload.subject } : item
          );
          setFilteredData(updatedData)
          message.success({content:`${response.data.message}`})
          setSubjectModal(false);
        }
      } catch (error) {
        message.error({content:"Something Went Wrong !"})
      }
    }

    const deleteEducationDatas = async(flag,id)=>{
      try {
        const response  = await axios.post(`${SERVER_ADDRESS}/api/deleteEducation`,{flag,id})
        if(response.status === 200 && response.data.result === 1 ){
          const updatedData = filteredData.filter(item=>item.id !== id)
          setFilteredData(updatedData)
          message.success({content:`${response.data.message}`})
        }
      } catch (error) {
        message.error({content:"Something went wrong !"})
      }
    }

    useEffect(()=>{
        setLoading(true)
        fetchEducation()
        fetchData(selectedOption)
    },[selectedOption]);

    const fetchEducation = async()=>{
      try {
        const response = await axios.post(`${SERVER_ADDRESS}/api/getEducationDetails`,{flag:1});
        if(response.status === 200 && response.data.result === 1){
          const options = response.data.data.map((item)=>({
            label:item.education_level,
            value:item.id
          }))
          setEducation(options)
        }
      } catch (error) {
        message.error({content:"Something Went Wrong !"})
      }
    }

    const fetchDegree = async(education_id)=>{
      try {
        const response = await axios.post(`${SERVER_ADDRESS}/api/getEducationDetails`,{flag:2,education_id});
        if(response.status === 200 && response.data.result === 1){
          const options = response.data.data.map((item)=>({
            label:item.degree,
            value:item.id
          }))
          setDegree(options)
        }
      } catch (error) {
        message.error({content:"Something Went Wrong !"})
      }
    }

    const handleEducationChange = (value)=>{
      setSelectedEducationId(value)
      fetchDegree(value)
      handleFilters({educationId:value})
    }

    const handleDegreeChange = (value)=>{
      setSelectedDegreeId(value)
      handleFilters({degreeId:value})
    }


    const fetchData =async (selectedOption)=>{
        try {
            const response = await axios.post(`${SERVER_ADDRESS}/api/getEducationDetails`,{type:selectedOption})
            setData(response.data.data)
            setFilteredData(response.data.data)
            setLoading(false)
        } catch (error) {
            console.log(error)
            message.error({content:"Oops Something Went Wrong !"})
        }
    }

    const education_columns = [
        {
            title:"Id",
            dataIndex:"id",
            key:"id",
            sorter:(a,b)=>a.id - b.id
        },
        {
            title:"Education Level",
            dataIndex:"education_level",
            key:"education_level"
        },
        {
            title:"Option",
            key:"option",
            render:(_,record)=>{
                return(
                    <div className='d-flex flex-row gap-2' >
                        <Tooltip title='Edit Education Level' >
                            <Button onClick ={()=>handleEducationEdit(record)} variant='filled' color='blue' ><EditFilled /></Button>
                        </Tooltip>
                        <Popconfirm onConfirm={()=>{deleteEducationDatas(1,record.id)}} title='Are You sure want to delete Education Level ?' >
                            <Button variant='filled' color='red' ><FaTrash /></Button>
                        </Popconfirm>
                    </div>
                )
            }
        }
    ]
    const degree_columns = [
        {
            title:"Id",
            key:"id",
            dataIndex:"id",
            sorter:(a,b)=>a.id - b.id
        },
        {
            title:"Education Level",
            key:"education_level",
            dataIndex:"education_level"
        },
        {
            title:"Degree",
            key:"degree",
            dataIndex:"degree"
        },
        {
            title:"Option",
            key:"option",
            render:(_,record)=>{
                return(
                    <div className='d-flex flex-row gap-2' >
                        <Tooltip title='Edit Education Level' >
                            <Button onClick ={()=>handleDegreeEdit(record)}   variant='filled' color='blue' ><EditFilled /></Button>
                        </Tooltip>
                        <Popconfirm onConfirm={()=>{deleteEducationDatas(1,record.id)}} title='Are You sure want to delete Education Level ?' >
                            <Button variant='filled' color='red' ><FaTrash /></Button>
                        </Popconfirm>
                    </div>
                )
            }
        },
    ]
    const subject_columns = [
        {
            title:"Id",
            key:"id",
            dataIndex:"id",
            sorter:(a,b)=>a.id - b.id
        },
        {
            title:"Education Level",
            key:"education_level",
            dataIndex:"education_level"
        },
        {
            title:"Degree",
            key:"degree",
            dataIndex:"degree"
        },
        {
            title:"Subject",
            key:"subject",
            dataIndex:"subject"
        },
        {
            title:"Option",
            key:"option",
            render:(_,record)=>{
                return(
                    <div className='d-flex flex-row gap-2' >
                        <Tooltip title='Edit Education Level' >
                            <Button onClick ={()=>handleSubjectEdit(record)}  variant='filled' color='blue' ><EditFilled /></Button>
                        </Tooltip>
                        <Popconfirm onConfirm={()=>{deleteEducationDatas(1,record.id)}} title='Are You sure want to delete Education Level ?' >
                            <Button onClick={()=>{deleteEducationDatas(3,record.id)}} variant='filled' color='red' ><FaTrash /></Button>
                        </Popconfirm>
                    </div>
                )
            }
        },
    ]

    const handleFilters = ({educationSearch=educationSearchTerm,degreeSearch=degreeSearchTerm,subjectSearch=subjectSearchTerm,educationId=selectedEducationId,degreeId=selectedDegreeId})=>{
      setEducationSearchTerm(educationSearch)
      setDegreeSearchTerm(degreeSearch);
      setSubjectSearchTerm(subjectSearch);
      setSelectedEducationId(educationId);
      setSelectedDegreeId(degreeId)

      let filtered = data;
      if (educationSearch) {
        filtered = filtered.filter(item => 
          item.education_level.toLowerCase().includes(educationSearch.toLowerCase())
        );
      }
      if (degreeSearch) {
        filtered = filtered.filter(item => 
          item.degree.toLowerCase().includes(degreeSearch.toLowerCase())
        );
      }
      if (subjectSearch) {
        filtered = filtered.filter(item => 
          item.subject.toLowerCase().includes(subjectSearch.toLowerCase())
        );
      }
      
      if (educationId) {
        filtered = filtered.filter(item => item.education_level_id === educationId);
      }
  
      if (degreeId) {
        filtered = filtered.filter(item => item.degree_id === degreeId);
      }

      setFilteredData(filtered)
    }

    const resetFilters = () => {
      setEducationSearchTerm('');
      setDegreeSearchTerm('');
      setSubjectSearchTerm('');
      setSelectedEducationId(null);
      setSelectedDegreeId(null);
      setFilteredData(data); // Reset to original data
    };

    const renderTable = ()=>{
        switch (selectedOption) {
              case 'Education Level':
                return (
                  <div>
                    <div style={{marginTop:"1rem"}} >
                    <Input 
                        placeholder='Search by Education Level' 
                        value={educationSearchTerm} 
                        onChange={(e) => handleFilters({ educationSearch: e.target.value })} 
                        style={{ width: "15rem" }} 
                        prefix={<SearchOutlined />} 
                      />
                    </div>
                    <Table style={{marginTop:"1rem"}} loading={loading} columns={education_columns} dataSource={filteredData} rowKey={'id'} />
                  </div>
                )
              case 'Degree':
                return(
                  <div>
                    <div className='d-flex flex-row gap-3'>
                      <Input 
                        placeholder='Search by Degree' 
                        value={degreeSearchTerm} 
                        onChange={(e) => handleFilters({ degreeSearch: e.target.value })} 
                        style={{ width: "15rem" }} 
                        prefix={<SearchOutlined />} 
                      />
                      <Select
                        showSearch
                        style={{ width: '20rem' }}
                        placeholder="Select a Education"
                        options={education}
                        onChange={(value) => handleFilters({ educationId: value })}
                        value={selectedEducationId}
                        optionFilterProp="label"
                        filterSort={(a, b) => (a?.label ?? '').toLowerCase().localeCompare((b?.label ?? '').toLowerCase())}
                      />
                      <Tooltip title='Reset Filter' >
                        <Button onClick={()=>{resetFilters()}} variant='filled' color='cyan' >
                          <GrPowerReset />
                        </Button>
                      </Tooltip>
                    </div>
                  <Table style={{ marginTop: "1rem" }} loading={loading} columns={degree_columns} dataSource={filteredData} rowKey={'id'} />
                </div>
        
                )
              case 'Subject':
                return (
                  <div>
                    <div className='d-flex flex-row gap-3'>
                      <Input 
                        placeholder='Search by Subject' 
                        value={subjectSearchTerm} 
                        onChange={(e) => handleFilters({ subjectSearch: e.target.value })} 
                        style={{ width: "15rem" }} 
                        prefix={<SearchOutlined />} 
                      />
                      <Select 
                        showSearch
                        style={{ width: '20rem' }}
                        placeholder="Select a Education"
                        options={education}
                        value={selectedEducationId}
                        onChange={(value)=>handleEducationChange(value)}
                        optionFilterProp="label"
                        filterSort={(a, b) => (a?.label ?? '').toLowerCase().localeCompare((b?.label ?? '').toLowerCase())}
                      />
                      <Select 
                        showSearch
                        style={{ width: '20rem' }}
                        placeholder="Select a Degree"
                        options={degree}
                        value={selectedDegreeId}
                        onChange={(value)=>handleDegreeChange(value)}
                        optionFilterProp="label"
                        filterSort={(a, b) => (a?.label ?? '').toLowerCase().localeCompare((b?.label ?? '').toLowerCase())}
                      />
                      <Tooltip title='Reset Filter' >
                        <Button onClick={()=>{resetFilters()}} variant='filled' color='cyan' >
                          <GrPowerReset />
                        </Button>
                      </Tooltip>
                    </div>
                    <Table style={{marginTop:"1rem"}} loading={loading} columns={subject_columns} dataSource={filteredData} rowKey={'id'} />
                  </div>
                )
              default:
                break;
            }
    }

  return (
    <div style={{marginTop:"4rem"}} >
        <Segmented style={{marginBottom:"2rem"}} selected={selectedOption} onChange={setSelectedOption} options={options} block />
        {renderTable()}
        <Modal width={'50%'} title={`Edit ${selectedOption}`} open={educationModal} onCancel={handleCloseEducationModal} footer={false} >
        <Form form={educationForm} onFinish={handleEducationUpdate} >
          <Form.Item label='Education Level' name='education_level' rules={[{required:true,message:"Enter Education Level"}]} >
            <Input placeholder='Enter Education Level' />
          </Form.Item>
          <Form.Item wrapperCol={{offset:10}}  >
            <Button type='primary' htmlType = 'submit' >
              Update
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      <Modal width={'50%'} title={`Edit ${selectedOption}`} open={degreeModal} onCancel={handleCloseDegreeModal} footer={false} >
        <Form form={degreeForm} onFinish={handleDegreeUpdate} >
          <Form.Item label='Education Level' name='education_level_id' rules={[{required:true,message:"Select Education Level"}]} >
            <Select showSearch
                placeholder="Select a Education Level"
                options={education}
                optionFilterProp="label"
                filterSort={(a, b) => (a?.label ?? '').toLowerCase().localeCompare((b?.label ?? '').toLowerCase())}/>
          </Form.Item>
          <Form.Item label='Degree' name='degree' rules={[{required:true,message:"Enter Degree"}]} >
            <Input placeholder='Enter Degree' />
          </Form.Item>
          <Form.Item wrapperCol={{offset:10}}  >
            <Button type='primary' htmlType = 'submit' >
              Update
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      <Modal width={'50%'} title={`Edit ${selectedOption}`} open={subjectModal} onCancel={handleCloseSubjectModal} footer={false} >
        <Form form={subjectForm} onFinish={handleSubjectUpdate} >
          <Form.Item label='Education' name='education_level_id' rules={[{required:true,message:"Select Education"}]} >
            <Select showSearch
                placeholder="Select a Education"
                options={education}
                onChange={(value)=>handleEducationChange(value)}
                optionFilterProp="label"
                filterSort={(a, b) => (a?.label ?? '').toLowerCase().localeCompare((b?.label ?? '').toLowerCase())}/>
          </Form.Item>
          <Form.Item label='Degree' name='degree_id' rules={[{required:true,message:"Select Degree"}]} >
            <Select showSearch
                placeholder="Select a Degree"
                options={degree}
                optionFilterProp="label"
                filterSort={(a, b) => (a?.label ?? '').toLowerCase().localeCompare((b?.label ?? '').toLowerCase())}/>
          </Form.Item>
          <Form.Item label='Subject' name='subject' rules={[{required:true,message:"Enter Subject"}]} >
            <Input placeholder='Enter Subject' />
          </Form.Item>
          <Form.Item wrapperCol={{offset:10}}  >
            <Button type='primary' htmlType = 'submit' >
              Update
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  )
}

export default ViewEducationDetails